import { render } from "./SampleUserComponent.vue?vue&type=template&id=4f30ee9d"
const script = {}

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__